import appConfig from "@/shared/config/app";
import { Avatar } from "@nextui-org/react";
import React from "react";

export interface VendorLogoProps {
  src: string;
  alt: string;
  className?: string;
  radius?: "sm" | "md" | "lg" | "full";
  size?: number
  needsAuthToken?: boolean;
}

const VendorLogo: React.FC<VendorLogoProps> = ({
  src,
  alt = "Vendor Logo",
  className = "",
  radius = "sm",
  size = 32,
  needsAuthToken = false,
}) => {
  return (
    <Avatar
      alt={alt}
      src={src + (src && needsAuthToken ? `?token=${appConfig.logoDevLogoKey}&size=${size * 4}` : "")}
      className={` rounded-full ${className}`}
      style={{ width: size, height: size }}
      radius={radius}
      name={alt.charAt(0).toUpperCase()}
    />
  );
};

export default VendorLogo;